export default __webpack_public_path__ + "static/media/giftboxes.e6da0fe9.jpg";